// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================
   RESOURCES LIST — resources-list.css
   ===================================================== */

/* ── Design Tokens ────────────────────────────────── */
:root {
  --res-gradient:   linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  --res-color:      #667eea;
  --res-shadow-sm:  0 2px 6px rgba(102, 126, 234, 0.2);
  --res-shadow-md:  0 3px 12px rgba(102, 126, 234, 0.4);
  --res-border:     2px solid #e0e0e0;
  --res-h-ctrl:     40px;
  --res-ease:       all 0.2s ease;
}

/* =====================================================
   BULK DELETE BUTTON
   ===================================================== */

.resources-delete-selected-btn {
  border-radius: 20px !important;
  padding: 0 16px !important;
  height: var(--res-h-ctrl) !important;
  min-height: var(--res-h-ctrl) !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  text-transform: none !important;
  transition: var(--res-ease) !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
  background: white !important;
  color: #e53935 !important;
  border: 2px solid #e53935 !important;
  box-shadow: 0 2px 6px rgba(229, 57, 53, 0.15) !important;
  margin: 0 !important;
}

.resources-delete-selected-btn md-icon {
  margin: 0 !important;
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
  color: #e53935 !important;
}

.resources-delete-selected-btn:not([disabled]):hover {
  background: #e53935 !important;
  color: white !important;
  box-shadow: 0 3px 12px rgba(229, 57, 53, 0.35) !important;
  transform: translateY(-1px) !important;
}

.resources-delete-selected-btn:not([disabled]):hover md-icon { color: white !important; }

.resources-delete-selected-btn[disabled],
.resources-delete-selected-btn.md-button[disabled],
.resources-delete-selected-btn.md-button[disabled]:hover {
  background: transparent !important;
  border-color: #d0d0d0 !important;
  color: #bdbdbd !important;
  box-shadow: none !important;
  opacity: 1 !important;
  cursor: not-allowed !important;
  transform: none !important;
}

.resources-delete-selected-btn[disabled] md-icon,
.resources-delete-selected-btn.md-button[disabled] md-icon { color: #bdbdbd !important; }

/* =====================================================
   FIXED ACTIONS BAR
   ===================================================== */

.resources-fixed-actions {
  background: white;
  padding: 10px 16px 12px;
  border-radius: 12px 12px 0 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-bottom: var(--res-border);
  display: flex;
  flex-direction: column;
  gap: 0;
}

.resources-fixed-row1 {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  flex-wrap: wrap;
  padding-bottom: 10px;
}

.resources-fixed-row2 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  border-top: 1px solid #f0f0f0;
  padding-top: 10px;
}

.resources-fixed-left,
.resources-fixed-middle {
  display: flex;
  align-items: center;
  gap: 10px;
}

.resources-fixed-right { display: flex; align-items: center; gap: 8px; }

/* Input containers */
.resources-select-container,
.resources-search-container { margin: 0 !important; padding: 0 !important; min-width: 160px; }

.resources-sort-container { margin: 0 !important; padding: 0 !important; min-width: 140px; }

.resources-pagesize-container { margin: 0 !important; padding: 0 !important; min-width: 90px; max-width: 90px; }

.resources-select-container > label,
.resources-search-container > label,
.resources-sort-container > label,
.resources-pagesize-container > label {
  position: static !important;
  font-size: 12px !important;
  color: #666 !important;
  font-weight: 500 !important;
  margin-bottom: 4px !important;
  transform: none !important;
  display: block !important;
}

.resources-pagesize-select .md-select-value            { padding-right: 20px !important; min-width: 0 !important; }
.resources-pagesize-select .md-select-value-label      { overflow: visible !important; }

.resources-select-container .md-errors-spacer,
.resources-search-container .md-errors-spacer,
.resources-sort-container .md-errors-spacer,
.resources-pagesize-container .md-errors-spacer        { display: none !important; min-height: 0 !important; }

.resources-select,
.resources-search-input {
  height: var(--res-h-ctrl) !important;
  min-height: var(--res-h-ctrl) !important;
  line-height: var(--res-h-ctrl) !important;
  padding: 0 12px !important;
  font-size: 14px !important;
  border: var(--res-border) !important;
  border-radius: 8px !important;
  background: white !important;
  transition: var(--res-ease) !important;
  margin: 0 !important;
}

.resources-select:focus,
.resources-search-input:focus {
  outline: none !important;
  border-color: var(--res-color) !important;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1) !important;
}

.resources-search-input { width: 100%; box-sizing: border-box !important; }

.resources-select .md-select-value {
  height: var(--res-h-ctrl) !important;
  min-height: var(--res-h-ctrl) !important;
  line-height: var(--res-h-ctrl) !important;
  padding: 0 !important;
  font-size: 14px !important;
  border: none !important;
}

/* Pagination */
.resources-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 0 8px;
  padding-top: 20px;
}

.resources-pagination-btn {
  width: var(--res-h-ctrl) !important;
  height: var(--res-h-ctrl) !important;
  min-width: var(--res-h-ctrl) !important;
  min-height: var(--res-h-ctrl) !important;
  padding: 0 !important;
  margin: 0 !important;
  border-radius: 8px !important;
  border: var(--res-border) !important;
  background: white !important;
  transition: var(--res-ease) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.resources-pagination-btn:not([disabled]) {
  background: var(--res-gradient) !important;
  border-color: transparent !important;
  box-shadow: var(--res-shadow-sm) !important;
}

.resources-pagination-btn:not([disabled]):hover {
  box-shadow: var(--res-shadow-md) !important;
  transform: translateY(-1px) scale(1.05);
}

.resources-pagination-btn[disabled] { opacity: 0.4 !important; cursor: not-allowed !important; background: #f5f5f5 !important; }

.resources-pagination-btn md-icon {
  font-size: 24px !important;
  width: 24px !important;
  height: 24px !important;
  line-height: 24px !important;
  margin: 0 !important;
  padding: 0 !important;
}

.resources-pagination-btn:not([disabled]) md-icon { color: white !important; }
.resources-pagination-btn[disabled] md-icon       { color: #bdbdbd !important; }

.resources-pagination-info {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
  background: #f8f9fa;
  border: var(--res-border);
  border-radius: 8px;
  height: var(--res-h-ctrl);
  min-width: 100px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Toolbar buttons */
.resources-new-btn,
.resources-import-btn {
  border-radius: 20px !important;
  padding: 0 16px !important;
  height: var(--res-h-ctrl) !important;
  min-height: var(--res-h-ctrl) !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  text-transform: none !important;
  transition: var(--res-ease) !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
}

.resources-new-btn md-icon,
.resources-import-btn md-icon { margin: 0 !important; font-size: 20px !important; width: 20px !important; height: 20px !important; }

.resources-new-btn {
  background: var(--res-gradient) !important;
  color: white !important;
  box-shadow: var(--res-shadow-sm) !important;
}

.resources-new-btn:hover { box-shadow: var(--res-shadow-md) !important; transform: translateY(-1px) !important; }

.resources-import-btn {
  background: white !important;
  color: #1e88e5 !important;
  border: 2px solid #1e88e5 !important;
  box-shadow: 0 2px 6px rgba(30, 136, 229, 0.15) !important;
}

.resources-import-btn:hover {
  background: #1e88e5 !important;
  color: white !important;
  box-shadow: 0 3px 12px rgba(30, 136, 229, 0.3) !important;
  transform: translateY(-1px) !important;
}

.resources-explorer-slot {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 16px;
  padding-left: 8px;
}
.resources-explorer-divider {
  width: 1px;
  height: 28px;
  background: #dfe2ec;
  flex-shrink: 0;
}
.resources-explorer-btn {
  margin: 0 !important;
  border-radius: 20px !important;
  padding: 0 16px !important;
  height: var(--res-h-ctrl) !important;
  min-height: var(--res-h-ctrl) !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  text-transform: none !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
  background: white !important;
  color: var(--res-color) !important;
  border: 2px solid var(--res-color) !important;
  box-shadow: var(--res-shadow-sm) !important;
  transition: var(--res-ease) !important;
}
.resources-explorer-btn md-icon { margin: 0 !important; font-size: 20px !important; width: 20px !important; height: 20px !important; color: inherit !important; }
.resources-explorer-btn:not([disabled]):hover {
  background: var(--res-gradient) !important;
  color: white !important;
  border-color: transparent !important;
  box-shadow: var(--res-shadow-md) !important;
  transform: translateY(-1px) !important;
}
.resources-explorer-btn[disabled] { color: #b0b4c4 !important; border-color: #dfe2ec !important; box-shadow: none !important; }

/* =====================================================
   COLUMN DEFINITIONS
   ===================================================== */

.rl-col-checkbox {
  flex: 0 0 44px;
  min-width: 44px;
  max-width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rl-col-identity     { flex: 0 1 34%; min-width: 0; }
.rl-col-type         { flex: 1 1 13%; min-width: 0; overflow: hidden; }
.rl-col-environments { flex: 1 1 12%; min-width: 0; }
.rl-col-created      { flex: 0 0 150px; min-width: 0; padding-right: 12px; }
.rl-col-updated      { flex: 0 0 82px; min-width: 0; }
.rl-col-toggle       { flex: 0 0 64px;  min-width: 0; }
.rl-col-actions      { flex: 0 0 84px; min-width: 0; }

/* Data row alignment */
.resource-row .rl-col-checkbox { display: flex; align-items: center; justify-content: center; }
.resource-row .rl-col-toggle   { display: flex; align-items: center; justify-content: center; }
.resource-row .rl-col-actions  { display: flex; align-items: center; justify-content: flex-start; gap: 2px; }

/* Header alignment */
.resources-list-header > .rl-col-checkbox { display: flex; align-items: center; justify-content: center; }
.resources-list-header > .rl-col-toggle   { display: flex; align-items: center; justify-content: center; }
.resources-list-header > .rl-col-actions  { padding-right: 0; }

/* =====================================================
   CHECKBOXES
   ===================================================== */

.resources-checkbox {
  margin: 0 !important;
  padding: 0 !important;
  min-height: 20px !important;
  height: 20px !important;
  width: 20px !important;
}

.resources-checkbox .md-container {
  position: relative !important;
  top: auto !important;
  left: auto !important;
  transform: none !important;
  margin: 0 !important;
  width: 20px !important;
  height: 20px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.resources-checkbox .md-label { display: none !important; }

.resources-checkbox--header.md-checked .md-icon {
  background-color: var(--res-color) !important;
  border-color: var(--res-color) !important;
}

.resource-row__checkbox-cell {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  align-self: center !important;
}

/* =====================================================
   LIST WRAPPER
   ===================================================== */

.resources-list-wrapper {
  background: white;
  border-radius: 0 0 12px 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.resources-list-header {
  display: flex;
  align-items: center;
  padding: 0 16px 0 20px;
  height: 40px;
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
  border-bottom: 2px solid #e8ecff;
  position: sticky;
  top: 0;
  z-index: 2;
}

.resources-list-header > div {
  font-size: 11px;
  font-weight: 700;
  color: var(--res-color);
  text-transform: uppercase;
  letter-spacing: 0.7px;
  padding-right: 12px;
}

.resources-list-header > .rl-col-actions { padding-right: 0; }

.resources-list { display: flex; flex-direction: column; }

/* =====================================================
   RESOURCE ROW
   ===================================================== */

.resource-row {
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 16px 0 20px;
  min-height: 64px;
  border-bottom: 1px solid #f0f0f0;
  background: white;
  transition: background 0.15s ease, box-shadow 0.15s ease;
  animation: rowFadeIn 0.25s ease both;
}

.resource-row:last-child  { border-bottom: none; }
.resource-row:hover       { background: #fafbff; box-shadow: inset 0 0 0 1px #e4e8ff; z-index: 1; }

.resource-row:nth-child(1)  { animation-delay: 0.02s; }
.resource-row:nth-child(2)  { animation-delay: 0.04s; }
.resource-row:nth-child(3)  { animation-delay: 0.06s; }
.resource-row:nth-child(4)  { animation-delay: 0.08s; }
.resource-row:nth-child(5)  { animation-delay: 0.10s; }
.resource-row:nth-child(6)  { animation-delay: 0.12s; }
.resource-row:nth-child(7)  { animation-delay: 0.14s; }
.resource-row:nth-child(8)  { animation-delay: 0.16s; }
.resource-row:nth-child(9)  { animation-delay: 0.18s; }
.resource-row:nth-child(10) { animation-delay: 0.20s; }

.resource-row__stripe {
  position: absolute;
  left: 0; top: 0; bottom: 0;
  width: 4px;
  background: #e0e0e0;
  transition: background 0.2s ease;
}

.resource-row--enabled   .resource-row__stripe { background: var(--res-gradient); }
.resource-row--attention .resource-row__stripe { background: linear-gradient(180deg, #ff9800 0%, #f57c00 100%); }

.resource-row--selected {
  background: rgba(102, 126, 234, 0.06) !important;
  box-shadow: inset 3px 0 0 var(--res-color) !important;
}

.resource-row--selected:hover { background: rgba(102, 126, 234, 0.1) !important; }

/* Identity column */
.resource-row__identity { display: flex; flex-direction: column; gap: 3px; padding-right: 16px; min-width: 0; }

.resource-row__name-line { display: flex; align-items: center; flex-wrap: wrap; gap: 6px; }

.resource-row__name {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a2e;
  overflow-wrap: anywhere;
  white-space: normal;
  max-width: 100%;
  flex-basis: 100%;
  line-height: 1.4;
  flex-shrink: 1;
}

.resource-row__desc {
  font-size: 12px;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  line-height: 1.3;
}

/* Attention badge */
.resource-row__attn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 4px;
  max-width: fit-content;
}

.resource-row__attn-icon  { color: #ff9800 !important; font-size: 14px !important; width: 14px !important; height: 14px !important; flex-shrink: 0; }
.resource-row__attn-msg   { font-size: 11px; color: #856404; font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 200px; }

/* Type column */
.resource-row__type { padding-right: 8px; overflow: hidden; }

.resource-row__type generic-type-pill,
.resource-row__type > * {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Environments column */
.resource-row__environments { display: flex; flex-wrap: wrap; align-items: center; gap: 4px; padding-right: 12px; }
.resource-row__no-env       { font-size: 12px; color: #bdbdbd; font-style: italic; }

/* Date cells */
.resource-row__date-cell { display: flex; align-items: center; padding-right: 12px; }
.resource-row__date-value { font-size: 12px; color: #555; font-weight: 500; line-height: 1.4; }

/* Switch */
.resource-row__switch                       { margin: 0 !important; }
.resource-row__switch .md-label             { display: none !important; }
.resource-row__switch .md-container         { margin: 0 auto !important; }

/* Action icons */
.resource-row__action-icon {
  color: #9e9e9e;
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  border-radius: 6px;
  background: transparent;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 18px !important;
  transition: var(--res-ease);
  margin: 0 !important;
}

.resource-row__action-icon:hover {
  color: var(--res-color);
  background: rgba(102, 126, 234, 0.08);
  border-color: rgba(102, 126, 234, 0.25);
  transform: translateY(-1px);
}

.resource-row__action-icon.confirm-delete {
  color: #f44336;
  background: #ffebee;
  border-color: #f44336;
  animation: pulse-delete 1s ease-in-out infinite;
}

.resource-row__action-icon.confirm-delete:hover { background: #f44336; color: white; }

/* List footer */
.resources-list-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 20px;
  border-top: 1px solid #f0f0f0;
  background: #fafbfc;
}

.resources-list-count        { font-size: 12px; color: #999; }
.resources-list-count strong { color: #555; font-weight: 600; }
.resources-list-selected-hint { color: var(--res-color); font-weight: 500; }

/* =====================================================
   BADGES
   ===================================================== */

.resource-id-pill {
  display: inline-flex;
  align-items: center;
  background: rgba(102, 126, 234, 0.1);
  color: var(--res-color);
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 600;
  font-family: 'Monaco', monospace;
  white-space: nowrap;
  flex-shrink: 0;
}

.resource-origin-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
  transition: var(--res-ease);
}

.resource-origin-badge i { font-size: 11px; }

.resource-origin-badge.origin-manual   { background: rgba(158, 158, 158, 0.1); color: #757575; border: 1px solid rgba(158, 158, 158, 0.3); }
.resource-origin-badge.origin-manual i { color: #9e9e9e; }

.resource-origin-badge.origin-imported   { background: rgba(30, 136, 229, 0.1); color: #1565c0; border: 1px solid rgba(30, 136, 229, 0.3); }
.resource-origin-badge.origin-imported i { color: #1e88e5; }

.resources-empty-btn-icon { margin-right: 6px !important; font-size: 18px !important; width: 18px !important; height: 18px !important; }

/* =====================================================
   SHARED UTILITIES
   ===================================================== */

.resources-fixed-actions md-select .md-select-value { color: #424242; opacity: 1; }

/* Tooltip look: standardized in common/styles/shared-components.css (.md-tooltip) */

.datasource-status-badge { display: inline-flex; align-items: center; gap: 4px; padding: 4px 12px; border-radius: 12px; font-size: 12px; font-weight: 500; margin-left: 12px; }
.datasource-status-badge md-icon { font-size: 16px; width: 16px; height: 16px; }
.datasource-status-badge.status-online  { background-color: #e8f5e9; color: #2e7d32; }
.datasource-status-badge.status-online  md-icon { color: #4caf50; }
.datasource-status-badge.status-offline { background-color: #ffebee; color: #c62828; }
.datasource-status-badge.status-offline md-icon { color: #f44336; }

/* =====================================================
   ANIMATIONS
   ===================================================== */

@keyframes fadeIn     { from { opacity: 0; transform: translateY(10px);  } to { opacity: 1; transform: translateY(0); } }
@keyframes rowFadeIn  { from { opacity: 0; transform: translateX(-6px);  } to { opacity: 1; transform: translateX(0); } }

@keyframes pulse-delete {
  0%, 100% { box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4); }
  50%       { box-shadow: 0 0 0 4px rgba(244, 67, 54, 0); }
}

@keyframes pulse-icon {
  0%, 100% { transform: scale(1);    opacity: 0.8; }
  50%       { transform: scale(1.05); opacity: 1;   }
}

/* =====================================================
   RESPONSIVE
   ===================================================== */

@media (max-width: 1100px) {
  .rl-col-identity     { flex: 1 1 30%; }
  .rl-col-type         { flex: 0 0 14%; }
  .rl-col-environments { flex: 0 0 14%; }
  .rl-col-created      { flex: 0 0 10%; }
  .rl-col-updated      { flex: 0 0 10%; }
}

@media (max-width: 900px) {
  .rl-col-created,
  .rl-col-updated  { display: none; }
  .rl-col-identity { flex: 1 1 35%; }
  .rl-col-type     { flex: 0 0 14%; }
  .rl-col-environments { flex: 0 0 24%; }
}

@media (max-width: 768px) {
  .resources-fixed-row1                  { flex-wrap: wrap; gap: 8px; }
  .resources-fixed-row2                  { justify-content: stretch; }
  .resources-fixed-row2 > *             { flex: 1; }
  .resources-explorer-slot               { margin-left: 0; padding-left: 0; }
  .resources-explorer-divider            { display: none; }
  .resources-explorer-slot > .md-button  { flex: 1; }
  .resources-fixed-left,
  .resources-fixed-middle,
  .resources-fixed-right                 { width: 100%; margin-left: 0; }
  .resources-list-header                 { display: none; }
  .resource-row                          { flex-wrap: wrap; padding: 12px 12px 12px 18px; gap: 8px; align-items: flex-start; }
  .rl-col-checkbox,
  .rl-col-identity,
  .rl-col-type,
  .rl-col-environments,
  .rl-col-created,
  .rl-col-updated,
  .rl-col-toggle,
  .rl-col-actions                        { flex: 0 0 auto !important; }
  .rl-col-checkbox                       { width: 44px; }
  .rl-col-identity                       { width: calc(100% - 44px); }
  .rl-col-type                           { width: auto; }
  .rl-col-environments                   { width: 100%; }
  .rl-col-created,
  .rl-col-updated                        { display: none; }
  .rl-col-toggle                         { margin-left: auto; }
  .rl-col-actions                        { width: auto; }
}
/* Full resource identity, with a separate readable ID line. */
.resource-row__identity .resource-id-pill { max-width: 100%; min-width: 0; flex-shrink: 1; }
.resource-row__identity .bm-id { max-width: 100%; min-width: 0; }
.resource-row__identity .bm-id-value { white-space: normal; overflow-wrap: anywhere; }
.resource-row .rl-col-created .bm-user { max-width: 100%; }
.resource-row .rl-col-created .bm-user-name { white-space: normal; overflow-wrap: anywhere; }

.resource-filter-error { margin: 12px 0; padding: 12px 16px; color: #b42318; background: #fef3f2; border-radius: 6px; }
`, "",{"version":3,"sources":["webpack://./profile/tabs/resources/resources-tab.css"],"names":[],"mappings":"AAAA;;0DAE0D;;AAE1D,wDAAwD;AACxD;EACE,mEAAmE;EACnE,yBAAyB;EACzB,oDAAoD;EACpD,qDAAqD;EACrD,mCAAmC;EACnC,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;;0DAE0D;;AAE1D;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,oCAAoC;EACpC,wCAAwC;EACxC,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;EAC/B,sCAAsC;EACtC,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB;EACzB,oCAAoC;EACpC,wDAAwD;EACxD,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,yDAAyD;EACzD,sCAAsC;AACxC;;AAEA,+DAA+D,uBAAuB,EAAE;;AAExF;;;EAGE,kCAAkC;EAClC,gCAAgC;EAChC,yBAAyB;EACzB,2BAA2B;EAC3B,qBAAqB;EACrB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;6DAC6D,yBAAyB,EAAE;;AAExF;;0DAE0D;;AAE1D;EACE,iBAAiB;EACjB,uBAAuB;EACvB,4BAA4B;EAC5B,yCAAyC;EACzC,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;AAEvE,qBAAqB;AACrB;8BAC8B,oBAAoB,EAAE,qBAAqB,EAAE,gBAAgB,EAAE;;AAE7F,4BAA4B,oBAAoB,EAAE,qBAAqB,EAAE,gBAAgB,EAAE;;AAE3F,gCAAgC,oBAAoB,EAAE,qBAAqB,EAAE,eAAe,EAAE,eAAe,EAAE;;AAE/G;;;;EAIE,2BAA2B;EAC3B,0BAA0B;EAC1B,sBAAsB;EACtB,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA,yDAAyD,8BAA8B,EAAE,uBAAuB,EAAE;AAClH,yDAAyD,4BAA4B,EAAE;;AAEvF;;;yDAGyD,wBAAwB,EAAE,wBAAwB,EAAE;;AAE7G;;EAEE,oCAAoC;EACpC,wCAAwC;EACxC,yCAAyC;EACzC,0BAA0B;EAC1B,0BAA0B;EAC1B,oCAAoC;EACpC,6BAA6B;EAC7B,4BAA4B;EAC5B,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;;EAEE,wBAAwB;EACxB,yCAAyC;EACzC,yDAAyD;AAC3D;;AAEA,0BAA0B,WAAW,EAAE,iCAAiC,EAAE;;AAE1E;EACE,oCAAoC;EACpC,wCAAwC;EACxC,yCAAyC;EACzC,qBAAqB;EACrB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,uCAAuC;EACvC,wCAAwC;EACxC,qBAAqB;EACrB,oBAAoB;EACpB,6BAA6B;EAC7B,oCAAoC;EACpC,4BAA4B;EAC5B,sCAAsC;EACtC,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA,sCAAsC,uBAAuB,EAAE,8BAA8B,EAAE,8BAA8B,EAAE;;AAE/H;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,oDAAoD,uBAAuB,EAAE;AAC7E,oDAAoD,yBAAyB,EAAE;;AAE/E;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;;EAEE,8BAA8B;EAC9B,0BAA0B;EAC1B,oCAAoC;EACpC,wCAAwC;EACxC,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;EAC/B,sCAAsC;EACtC,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;gCACgC,oBAAoB,EAAE,0BAA0B,EAAE,sBAAsB,EAAE,uBAAuB,EAAE;;AAEnI;EACE,0CAA0C;EAC1C,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA,2BAA2B,2CAA2C,EAAE,sCAAsC,EAAE;;AAEhH;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,oCAAoC;EACpC,yDAAyD;AAC3D;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,yDAAyD;EACzD,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,0BAA0B;EAC1B,oCAAoC;EACpC,wCAAwC;EACxC,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,kCAAkC;EAClC,6CAA6C;EAC7C,2CAA2C;EAC3C,sCAAsC;AACxC;AACA,kCAAkC,oBAAoB,EAAE,0BAA0B,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,yBAAyB,EAAE;AAChK;EACE,0CAA0C;EAC1C,uBAAuB;EACvB,oCAAoC;EACpC,2CAA2C;EAC3C,sCAAsC;AACxC;AACA,oCAAoC,yBAAyB,EAAE,gCAAgC,EAAE,2BAA2B,EAAE;;AAE9H;;0DAE0D;;AAE1D;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,uBAAuB,aAAa,EAAE,YAAY,EAAE;AACpD,uBAAuB,aAAa,EAAE,YAAY,EAAE,gBAAgB,EAAE;AACtE,uBAAuB,aAAa,EAAE,YAAY,EAAE;AACpD,uBAAuB,eAAe,EAAE,YAAY,EAAE,mBAAmB,EAAE;AAC3E,uBAAuB,cAAc,EAAE,YAAY,EAAE;AACrD,uBAAuB,cAAc,GAAG,YAAY,EAAE;AACtD,uBAAuB,cAAc,EAAE,YAAY,EAAE;;AAErD,uBAAuB;AACvB,iCAAiC,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AAC9F,iCAAiC,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AAC9F,iCAAiC,aAAa,EAAE,mBAAmB,EAAE,2BAA2B,EAAE,QAAQ,EAAE;;AAE5G,qBAAqB;AACrB,4CAA4C,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AACzG,4CAA4C,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AACzG,4CAA4C,gBAAgB,EAAE;;AAE9D;;0DAE0D;;AAE1D;EACE,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,0BAA0B;EAC1B,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,gCAAgC,wBAAwB,EAAE;;AAE1D;EACE,6CAA6C;EAC7C,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;;0DAE0D;;AAE1D;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,6DAA6D;EAC7D,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,2CAA2C,gBAAgB,EAAE;;AAE7D,kBAAkB,aAAa,EAAE,sBAAsB,EAAE;;AAEzD;;0DAE0D;;AAE1D;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,wDAAwD;EACxD,oCAAoC;AACtC;;AAEA,4BAA4B,mBAAmB,EAAE;AACjD,4BAA4B,mBAAmB,EAAE,mCAAmC,EAAE,UAAU,EAAE;;AAElG,8BAA8B,sBAAsB,EAAE;AACtD,8BAA8B,sBAAsB,EAAE;AACtD,8BAA8B,sBAAsB,EAAE;AACtD,8BAA8B,sBAAsB,EAAE;AACtD,8BAA8B,sBAAsB,EAAE;AACtD,8BAA8B,sBAAsB,EAAE;AACtD,8BAA8B,sBAAsB,EAAE;AACtD,8BAA8B,sBAAsB,EAAE;AACtD,8BAA8B,sBAAsB,EAAE;AACtD,8BAA8B,sBAAsB,EAAE;;AAEtD;EACE,kBAAkB;EAClB,OAAO,EAAE,MAAM,EAAE,SAAS;EAC1B,UAAU;EACV,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,iDAAiD,+BAA+B,EAAE;AAClF,iDAAiD,6DAA6D,EAAE;;AAEhH;EACE,gDAAgD;EAChD,qDAAqD;AACvD;;AAEA,gCAAgC,+CAA+C,EAAE;;AAEjF,oBAAoB;AACpB,0BAA0B,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,mBAAmB,EAAE,YAAY,EAAE;;AAE9G,2BAA2B,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,QAAQ,EAAE;;AAE1F;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,4BAA4B,yBAAyB,EAAE,0BAA0B,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,cAAc,EAAE;AACpJ,4BAA4B,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,gBAAgB,EAAE;;AAEjK,gBAAgB;AAChB,sBAAsB,kBAAkB,EAAE,gBAAgB,EAAE;;AAE5D;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB,8BAA8B,aAAa,EAAE,eAAe,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAClH,8BAA8B,eAAe,EAAE,cAAc,EAAE,kBAAkB,EAAE;;AAEnF,eAAe;AACf,2BAA2B,aAAa,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AACpF,4BAA4B,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AAE9F,WAAW;AACX,8CAA8C,oBAAoB,EAAE;AACpE,8CAA8C,wBAAwB,EAAE;AACxE,8CAA8C,yBAAyB,EAAE;;AAEzE,iBAAiB;AACjB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA,kDAAkD,mBAAmB,EAAE,YAAY,EAAE;;AAErF,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,+BAA+B,eAAe,EAAE,WAAW,EAAE;AAC7D,+BAA+B,WAAW,EAAE,gBAAgB,EAAE;AAC9D,gCAAgC,uBAAuB,EAAE,gBAAgB,EAAE;;AAE3E;;0DAE0D;;AAE1D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oCAAoC;EACpC,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA,2BAA2B,eAAe,EAAE;;AAE5C,yCAAyC,oCAAoC,EAAE,cAAc,EAAE,0CAA0C,EAAE;AAC3I,yCAAyC,cAAc,EAAE;;AAEzD,2CAA2C,mCAAmC,EAAE,cAAc,EAAE,yCAAyC,EAAE;AAC3I,2CAA2C,cAAc,EAAE;;AAE3D,4BAA4B,4BAA4B,EAAE,0BAA0B,EAAE,sBAAsB,EAAE,uBAAuB,EAAE;;AAEvI;;0DAE0D;;AAE1D,sDAAsD,cAAc,EAAE,UAAU,EAAE;;AAElF,oFAAoF;;AAEpF,2BAA2B,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AAC9K,mCAAmC,eAAe,EAAE,WAAW,EAAE,YAAY,EAAE;AAC/E,0CAA0C,yBAAyB,EAAE,cAAc,EAAE;AACrF,kDAAkD,cAAc,EAAE;AAClE,0CAA0C,yBAAyB,EAAE,cAAc,EAAE;AACrF,kDAAkD,cAAc,EAAE;;AAElE;;0DAE0D;;AAE1D,wBAAwB,OAAO,UAAU,EAAE,2BAA2B,GAAG,EAAE,KAAK,UAAU,EAAE,wBAAwB,EAAE,EAAE;AACxH,wBAAwB,OAAO,UAAU,EAAE,2BAA2B,GAAG,EAAE,KAAK,UAAU,EAAE,wBAAwB,EAAE,EAAE;;AAExH;EACE,WAAW,0CAA0C,EAAE;EACvD,YAAY,0CAA0C,EAAE;AAC1D;;AAEA;EACE,WAAW,mBAAmB,KAAK,YAAY,EAAE;EACjD,YAAY,sBAAsB,EAAE,UAAU,IAAI;AACpD;;AAEA;;0DAE0D;;AAE1D;EACE,uBAAuB,aAAa,EAAE;EACtC,uBAAuB,aAAa,EAAE;EACtC,uBAAuB,aAAa,EAAE;EACtC,uBAAuB,aAAa,EAAE;EACtC,uBAAuB,aAAa,EAAE;AACxC;;AAEA;EACE;qBACmB,aAAa,EAAE;EAClC,mBAAmB,aAAa,EAAE;EAClC,mBAAmB,aAAa,EAAE;EAClC,uBAAuB,aAAa,EAAE;AACxC;;AAEA;EACE,yCAAyC,eAAe,EAAE,QAAQ,EAAE;EACpE,yCAAyC,wBAAwB,EAAE;EACnE,wCAAwC,OAAO,EAAE;EACjD,yCAAyC,cAAc,EAAE,eAAe,EAAE;EAC1E,yCAAyC,aAAa,EAAE;EACxD,yCAAyC,OAAO,EAAE;EAClD;;2CAEyC,WAAW,EAAE,cAAc,EAAE;EACtE,yCAAyC,aAAa,EAAE;EACxD,yCAAyC,eAAe,EAAE,4BAA4B,EAAE,QAAQ,EAAE,uBAAuB,EAAE;EAC3H;;;;;;;2CAOyC,yBAAyB,EAAE;EACpE,yCAAyC,WAAW,EAAE;EACtD,yCAAyC,wBAAwB,EAAE;EACnE,yCAAyC,WAAW,EAAE;EACtD,yCAAyC,WAAW,EAAE;EACtD;2CACyC,aAAa,EAAE;EACxD,yCAAyC,iBAAiB,EAAE;EAC5D,yCAAyC,WAAW,EAAE;AACxD;AACA,8DAA8D;AAC9D,4CAA4C,eAAe,EAAE,YAAY,EAAE,cAAc,EAAE;AAC3F,iCAAiC,eAAe,EAAE,YAAY,EAAE;AAChE,uCAAuC,mBAAmB,EAAE,uBAAuB,EAAE;AACrF,yCAAyC,eAAe,EAAE;AAC1D,8CAA8C,mBAAmB,EAAE,uBAAuB,EAAE;;AAE5F,yBAAyB,cAAc,EAAE,kBAAkB,EAAE,cAAc,EAAE,mBAAmB,EAAE,kBAAkB,EAAE","sourcesContent":["/* =====================================================\n   RESOURCES LIST — resources-list.css\n   ===================================================== */\n\n/* ── Design Tokens ────────────────────────────────── */\n:root {\n  --res-gradient:   linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  --res-color:      #667eea;\n  --res-shadow-sm:  0 2px 6px rgba(102, 126, 234, 0.2);\n  --res-shadow-md:  0 3px 12px rgba(102, 126, 234, 0.4);\n  --res-border:     2px solid #e0e0e0;\n  --res-h-ctrl:     40px;\n  --res-ease:       all 0.2s ease;\n}\n\n/* =====================================================\n   BULK DELETE BUTTON\n   ===================================================== */\n\n.resources-delete-selected-btn {\n  border-radius: 20px !important;\n  padding: 0 16px !important;\n  height: var(--res-h-ctrl) !important;\n  min-height: var(--res-h-ctrl) !important;\n  font-weight: 600 !important;\n  font-size: 13px !important;\n  text-transform: none !important;\n  transition: var(--res-ease) !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n  background: white !important;\n  color: #e53935 !important;\n  border: 2px solid #e53935 !important;\n  box-shadow: 0 2px 6px rgba(229, 57, 53, 0.15) !important;\n  margin: 0 !important;\n}\n\n.resources-delete-selected-btn md-icon {\n  margin: 0 !important;\n  font-size: 18px !important;\n  width: 18px !important;\n  height: 18px !important;\n  color: #e53935 !important;\n}\n\n.resources-delete-selected-btn:not([disabled]):hover {\n  background: #e53935 !important;\n  color: white !important;\n  box-shadow: 0 3px 12px rgba(229, 57, 53, 0.35) !important;\n  transform: translateY(-1px) !important;\n}\n\n.resources-delete-selected-btn:not([disabled]):hover md-icon { color: white !important; }\n\n.resources-delete-selected-btn[disabled],\n.resources-delete-selected-btn.md-button[disabled],\n.resources-delete-selected-btn.md-button[disabled]:hover {\n  background: transparent !important;\n  border-color: #d0d0d0 !important;\n  color: #bdbdbd !important;\n  box-shadow: none !important;\n  opacity: 1 !important;\n  cursor: not-allowed !important;\n  transform: none !important;\n}\n\n.resources-delete-selected-btn[disabled] md-icon,\n.resources-delete-selected-btn.md-button[disabled] md-icon { color: #bdbdbd !important; }\n\n/* =====================================================\n   FIXED ACTIONS BAR\n   ===================================================== */\n\n.resources-fixed-actions {\n  background: white;\n  padding: 10px 16px 12px;\n  border-radius: 12px 12px 0 0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  border-bottom: var(--res-border);\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.resources-fixed-row1 {\n  display: flex;\n  align-items: flex-end;\n  gap: 10px;\n  flex-wrap: wrap;\n  padding-bottom: 10px;\n}\n\n.resources-fixed-row2 {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  border-top: 1px solid #f0f0f0;\n  padding-top: 10px;\n}\n\n.resources-fixed-left,\n.resources-fixed-middle {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.resources-fixed-right { display: flex; align-items: center; gap: 8px; }\n\n/* Input containers */\n.resources-select-container,\n.resources-search-container { margin: 0 !important; padding: 0 !important; min-width: 160px; }\n\n.resources-sort-container { margin: 0 !important; padding: 0 !important; min-width: 140px; }\n\n.resources-pagesize-container { margin: 0 !important; padding: 0 !important; min-width: 90px; max-width: 90px; }\n\n.resources-select-container > label,\n.resources-search-container > label,\n.resources-sort-container > label,\n.resources-pagesize-container > label {\n  position: static !important;\n  font-size: 12px !important;\n  color: #666 !important;\n  font-weight: 500 !important;\n  margin-bottom: 4px !important;\n  transform: none !important;\n  display: block !important;\n}\n\n.resources-pagesize-select .md-select-value            { padding-right: 20px !important; min-width: 0 !important; }\n.resources-pagesize-select .md-select-value-label      { overflow: visible !important; }\n\n.resources-select-container .md-errors-spacer,\n.resources-search-container .md-errors-spacer,\n.resources-sort-container .md-errors-spacer,\n.resources-pagesize-container .md-errors-spacer        { display: none !important; min-height: 0 !important; }\n\n.resources-select,\n.resources-search-input {\n  height: var(--res-h-ctrl) !important;\n  min-height: var(--res-h-ctrl) !important;\n  line-height: var(--res-h-ctrl) !important;\n  padding: 0 12px !important;\n  font-size: 14px !important;\n  border: var(--res-border) !important;\n  border-radius: 8px !important;\n  background: white !important;\n  transition: var(--res-ease) !important;\n  margin: 0 !important;\n}\n\n.resources-select:focus,\n.resources-search-input:focus {\n  outline: none !important;\n  border-color: var(--res-color) !important;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1) !important;\n}\n\n.resources-search-input { width: 100%; box-sizing: border-box !important; }\n\n.resources-select .md-select-value {\n  height: var(--res-h-ctrl) !important;\n  min-height: var(--res-h-ctrl) !important;\n  line-height: var(--res-h-ctrl) !important;\n  padding: 0 !important;\n  font-size: 14px !important;\n  border: none !important;\n}\n\n/* Pagination */\n.resources-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 0 8px;\n  padding-top: 20px;\n}\n\n.resources-pagination-btn {\n  width: var(--res-h-ctrl) !important;\n  height: var(--res-h-ctrl) !important;\n  min-width: var(--res-h-ctrl) !important;\n  min-height: var(--res-h-ctrl) !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  border-radius: 8px !important;\n  border: var(--res-border) !important;\n  background: white !important;\n  transition: var(--res-ease) !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.resources-pagination-btn:not([disabled]) {\n  background: var(--res-gradient) !important;\n  border-color: transparent !important;\n  box-shadow: var(--res-shadow-sm) !important;\n}\n\n.resources-pagination-btn:not([disabled]):hover {\n  box-shadow: var(--res-shadow-md) !important;\n  transform: translateY(-1px) scale(1.05);\n}\n\n.resources-pagination-btn[disabled] { opacity: 0.4 !important; cursor: not-allowed !important; background: #f5f5f5 !important; }\n\n.resources-pagination-btn md-icon {\n  font-size: 24px !important;\n  width: 24px !important;\n  height: 24px !important;\n  line-height: 24px !important;\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n.resources-pagination-btn:not([disabled]) md-icon { color: white !important; }\n.resources-pagination-btn[disabled] md-icon       { color: #bdbdbd !important; }\n\n.resources-pagination-info {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n  white-space: nowrap;\n  background: #f8f9fa;\n  border: var(--res-border);\n  border-radius: 8px;\n  height: var(--res-h-ctrl);\n  min-width: 100px;\n  padding: 0 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Toolbar buttons */\n.resources-new-btn,\n.resources-import-btn {\n  border-radius: 20px !important;\n  padding: 0 16px !important;\n  height: var(--res-h-ctrl) !important;\n  min-height: var(--res-h-ctrl) !important;\n  font-weight: 600 !important;\n  font-size: 13px !important;\n  text-transform: none !important;\n  transition: var(--res-ease) !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n}\n\n.resources-new-btn md-icon,\n.resources-import-btn md-icon { margin: 0 !important; font-size: 20px !important; width: 20px !important; height: 20px !important; }\n\n.resources-new-btn {\n  background: var(--res-gradient) !important;\n  color: white !important;\n  box-shadow: var(--res-shadow-sm) !important;\n}\n\n.resources-new-btn:hover { box-shadow: var(--res-shadow-md) !important; transform: translateY(-1px) !important; }\n\n.resources-import-btn {\n  background: white !important;\n  color: #1e88e5 !important;\n  border: 2px solid #1e88e5 !important;\n  box-shadow: 0 2px 6px rgba(30, 136, 229, 0.15) !important;\n}\n\n.resources-import-btn:hover {\n  background: #1e88e5 !important;\n  color: white !important;\n  box-shadow: 0 3px 12px rgba(30, 136, 229, 0.3) !important;\n  transform: translateY(-1px) !important;\n}\n\n.resources-explorer-slot {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding-left: 8px;\n}\n.resources-explorer-divider {\n  width: 1px;\n  height: 28px;\n  background: #dfe2ec;\n  flex-shrink: 0;\n}\n.resources-explorer-btn {\n  margin: 0 !important;\n  border-radius: 20px !important;\n  padding: 0 16px !important;\n  height: var(--res-h-ctrl) !important;\n  min-height: var(--res-h-ctrl) !important;\n  font-weight: 600 !important;\n  font-size: 13px !important;\n  text-transform: none !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n  background: white !important;\n  color: var(--res-color) !important;\n  border: 2px solid var(--res-color) !important;\n  box-shadow: var(--res-shadow-sm) !important;\n  transition: var(--res-ease) !important;\n}\n.resources-explorer-btn md-icon { margin: 0 !important; font-size: 20px !important; width: 20px !important; height: 20px !important; color: inherit !important; }\n.resources-explorer-btn:not([disabled]):hover {\n  background: var(--res-gradient) !important;\n  color: white !important;\n  border-color: transparent !important;\n  box-shadow: var(--res-shadow-md) !important;\n  transform: translateY(-1px) !important;\n}\n.resources-explorer-btn[disabled] { color: #b0b4c4 !important; border-color: #dfe2ec !important; box-shadow: none !important; }\n\n/* =====================================================\n   COLUMN DEFINITIONS\n   ===================================================== */\n\n.rl-col-checkbox {\n  flex: 0 0 44px;\n  min-width: 44px;\n  max-width: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.rl-col-identity     { flex: 0 1 34%; min-width: 0; }\n.rl-col-type         { flex: 1 1 13%; min-width: 0; overflow: hidden; }\n.rl-col-environments { flex: 1 1 12%; min-width: 0; }\n.rl-col-created      { flex: 0 0 150px; min-width: 0; padding-right: 12px; }\n.rl-col-updated      { flex: 0 0 82px; min-width: 0; }\n.rl-col-toggle       { flex: 0 0 64px;  min-width: 0; }\n.rl-col-actions      { flex: 0 0 84px; min-width: 0; }\n\n/* Data row alignment */\n.resource-row .rl-col-checkbox { display: flex; align-items: center; justify-content: center; }\n.resource-row .rl-col-toggle   { display: flex; align-items: center; justify-content: center; }\n.resource-row .rl-col-actions  { display: flex; align-items: center; justify-content: flex-start; gap: 2px; }\n\n/* Header alignment */\n.resources-list-header > .rl-col-checkbox { display: flex; align-items: center; justify-content: center; }\n.resources-list-header > .rl-col-toggle   { display: flex; align-items: center; justify-content: center; }\n.resources-list-header > .rl-col-actions  { padding-right: 0; }\n\n/* =====================================================\n   CHECKBOXES\n   ===================================================== */\n\n.resources-checkbox {\n  margin: 0 !important;\n  padding: 0 !important;\n  min-height: 20px !important;\n  height: 20px !important;\n  width: 20px !important;\n}\n\n.resources-checkbox .md-container {\n  position: relative !important;\n  top: auto !important;\n  left: auto !important;\n  transform: none !important;\n  margin: 0 !important;\n  width: 20px !important;\n  height: 20px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.resources-checkbox .md-label { display: none !important; }\n\n.resources-checkbox--header.md-checked .md-icon {\n  background-color: var(--res-color) !important;\n  border-color: var(--res-color) !important;\n}\n\n.resource-row__checkbox-cell {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  align-self: center !important;\n}\n\n/* =====================================================\n   LIST WRAPPER\n   ===================================================== */\n\n.resources-list-wrapper {\n  background: white;\n  border-radius: 0 0 12px 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.resources-list-header {\n  display: flex;\n  align-items: center;\n  padding: 0 16px 0 20px;\n  height: 40px;\n  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);\n  border-bottom: 2px solid #e8ecff;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\n.resources-list-header > div {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--res-color);\n  text-transform: uppercase;\n  letter-spacing: 0.7px;\n  padding-right: 12px;\n}\n\n.resources-list-header > .rl-col-actions { padding-right: 0; }\n\n.resources-list { display: flex; flex-direction: column; }\n\n/* =====================================================\n   RESOURCE ROW\n   ===================================================== */\n\n.resource-row {\n  display: flex;\n  align-items: center;\n  position: relative;\n  padding: 0 16px 0 20px;\n  min-height: 64px;\n  border-bottom: 1px solid #f0f0f0;\n  background: white;\n  transition: background 0.15s ease, box-shadow 0.15s ease;\n  animation: rowFadeIn 0.25s ease both;\n}\n\n.resource-row:last-child  { border-bottom: none; }\n.resource-row:hover       { background: #fafbff; box-shadow: inset 0 0 0 1px #e4e8ff; z-index: 1; }\n\n.resource-row:nth-child(1)  { animation-delay: 0.02s; }\n.resource-row:nth-child(2)  { animation-delay: 0.04s; }\n.resource-row:nth-child(3)  { animation-delay: 0.06s; }\n.resource-row:nth-child(4)  { animation-delay: 0.08s; }\n.resource-row:nth-child(5)  { animation-delay: 0.10s; }\n.resource-row:nth-child(6)  { animation-delay: 0.12s; }\n.resource-row:nth-child(7)  { animation-delay: 0.14s; }\n.resource-row:nth-child(8)  { animation-delay: 0.16s; }\n.resource-row:nth-child(9)  { animation-delay: 0.18s; }\n.resource-row:nth-child(10) { animation-delay: 0.20s; }\n\n.resource-row__stripe {\n  position: absolute;\n  left: 0; top: 0; bottom: 0;\n  width: 4px;\n  background: #e0e0e0;\n  transition: background 0.2s ease;\n}\n\n.resource-row--enabled   .resource-row__stripe { background: var(--res-gradient); }\n.resource-row--attention .resource-row__stripe { background: linear-gradient(180deg, #ff9800 0%, #f57c00 100%); }\n\n.resource-row--selected {\n  background: rgba(102, 126, 234, 0.06) !important;\n  box-shadow: inset 3px 0 0 var(--res-color) !important;\n}\n\n.resource-row--selected:hover { background: rgba(102, 126, 234, 0.1) !important; }\n\n/* Identity column */\n.resource-row__identity { display: flex; flex-direction: column; gap: 3px; padding-right: 16px; min-width: 0; }\n\n.resource-row__name-line { display: flex; align-items: center; flex-wrap: wrap; gap: 6px; }\n\n.resource-row__name {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1a1a2e;\n  overflow-wrap: anywhere;\n  white-space: normal;\n  max-width: 100%;\n  flex-basis: 100%;\n  line-height: 1.4;\n  flex-shrink: 1;\n}\n\n.resource-row__desc {\n  font-size: 12px;\n  color: #888;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  line-height: 1.3;\n}\n\n/* Attention badge */\n.resource-row__attn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  background: #fff3cd;\n  border: 1px solid #ffc107;\n  border-radius: 4px;\n  max-width: fit-content;\n}\n\n.resource-row__attn-icon  { color: #ff9800 !important; font-size: 14px !important; width: 14px !important; height: 14px !important; flex-shrink: 0; }\n.resource-row__attn-msg   { font-size: 11px; color: #856404; font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 200px; }\n\n/* Type column */\n.resource-row__type { padding-right: 8px; overflow: hidden; }\n\n.resource-row__type generic-type-pill,\n.resource-row__type > * {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Environments column */\n.resource-row__environments { display: flex; flex-wrap: wrap; align-items: center; gap: 4px; padding-right: 12px; }\n.resource-row__no-env       { font-size: 12px; color: #bdbdbd; font-style: italic; }\n\n/* Date cells */\n.resource-row__date-cell { display: flex; align-items: center; padding-right: 12px; }\n.resource-row__date-value { font-size: 12px; color: #555; font-weight: 500; line-height: 1.4; }\n\n/* Switch */\n.resource-row__switch                       { margin: 0 !important; }\n.resource-row__switch .md-label             { display: none !important; }\n.resource-row__switch .md-container         { margin: 0 auto !important; }\n\n/* Action icons */\n.resource-row__action-icon {\n  color: #9e9e9e;\n  width: 32px;\n  height: 32px;\n  flex: 0 0 32px;\n  border-radius: 6px;\n  background: transparent;\n  border: 1px solid transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 18px !important;\n  transition: var(--res-ease);\n  margin: 0 !important;\n}\n\n.resource-row__action-icon:hover {\n  color: var(--res-color);\n  background: rgba(102, 126, 234, 0.08);\n  border-color: rgba(102, 126, 234, 0.25);\n  transform: translateY(-1px);\n}\n\n.resource-row__action-icon.confirm-delete {\n  color: #f44336;\n  background: #ffebee;\n  border-color: #f44336;\n  animation: pulse-delete 1s ease-in-out infinite;\n}\n\n.resource-row__action-icon.confirm-delete:hover { background: #f44336; color: white; }\n\n/* List footer */\n.resources-list-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 10px 20px;\n  border-top: 1px solid #f0f0f0;\n  background: #fafbfc;\n}\n\n.resources-list-count        { font-size: 12px; color: #999; }\n.resources-list-count strong { color: #555; font-weight: 600; }\n.resources-list-selected-hint { color: var(--res-color); font-weight: 500; }\n\n/* =====================================================\n   BADGES\n   ===================================================== */\n\n.resource-id-pill {\n  display: inline-flex;\n  align-items: center;\n  background: rgba(102, 126, 234, 0.1);\n  color: var(--res-color);\n  padding: 2px 8px;\n  border-radius: 8px;\n  font-size: 10px;\n  font-weight: 600;\n  font-family: 'Monaco', monospace;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.resource-origin-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 8px;\n  font-size: 10px;\n  font-weight: 600;\n  white-space: nowrap;\n  flex-shrink: 0;\n  transition: var(--res-ease);\n}\n\n.resource-origin-badge i { font-size: 11px; }\n\n.resource-origin-badge.origin-manual   { background: rgba(158, 158, 158, 0.1); color: #757575; border: 1px solid rgba(158, 158, 158, 0.3); }\n.resource-origin-badge.origin-manual i { color: #9e9e9e; }\n\n.resource-origin-badge.origin-imported   { background: rgba(30, 136, 229, 0.1); color: #1565c0; border: 1px solid rgba(30, 136, 229, 0.3); }\n.resource-origin-badge.origin-imported i { color: #1e88e5; }\n\n.resources-empty-btn-icon { margin-right: 6px !important; font-size: 18px !important; width: 18px !important; height: 18px !important; }\n\n/* =====================================================\n   SHARED UTILITIES\n   ===================================================== */\n\n.resources-fixed-actions md-select .md-select-value { color: #424242; opacity: 1; }\n\n/* Tooltip look: standardized in common/styles/shared-components.css (.md-tooltip) */\n\n.datasource-status-badge { display: inline-flex; align-items: center; gap: 4px; padding: 4px 12px; border-radius: 12px; font-size: 12px; font-weight: 500; margin-left: 12px; }\n.datasource-status-badge md-icon { font-size: 16px; width: 16px; height: 16px; }\n.datasource-status-badge.status-online  { background-color: #e8f5e9; color: #2e7d32; }\n.datasource-status-badge.status-online  md-icon { color: #4caf50; }\n.datasource-status-badge.status-offline { background-color: #ffebee; color: #c62828; }\n.datasource-status-badge.status-offline md-icon { color: #f44336; }\n\n/* =====================================================\n   ANIMATIONS\n   ===================================================== */\n\n@keyframes fadeIn     { from { opacity: 0; transform: translateY(10px);  } to { opacity: 1; transform: translateY(0); } }\n@keyframes rowFadeIn  { from { opacity: 0; transform: translateX(-6px);  } to { opacity: 1; transform: translateX(0); } }\n\n@keyframes pulse-delete {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4); }\n  50%       { box-shadow: 0 0 0 4px rgba(244, 67, 54, 0); }\n}\n\n@keyframes pulse-icon {\n  0%, 100% { transform: scale(1);    opacity: 0.8; }\n  50%       { transform: scale(1.05); opacity: 1;   }\n}\n\n/* =====================================================\n   RESPONSIVE\n   ===================================================== */\n\n@media (max-width: 1100px) {\n  .rl-col-identity     { flex: 1 1 30%; }\n  .rl-col-type         { flex: 0 0 14%; }\n  .rl-col-environments { flex: 0 0 14%; }\n  .rl-col-created      { flex: 0 0 10%; }\n  .rl-col-updated      { flex: 0 0 10%; }\n}\n\n@media (max-width: 900px) {\n  .rl-col-created,\n  .rl-col-updated  { display: none; }\n  .rl-col-identity { flex: 1 1 35%; }\n  .rl-col-type     { flex: 0 0 14%; }\n  .rl-col-environments { flex: 0 0 24%; }\n}\n\n@media (max-width: 768px) {\n  .resources-fixed-row1                  { flex-wrap: wrap; gap: 8px; }\n  .resources-fixed-row2                  { justify-content: stretch; }\n  .resources-fixed-row2 > *             { flex: 1; }\n  .resources-explorer-slot               { margin-left: 0; padding-left: 0; }\n  .resources-explorer-divider            { display: none; }\n  .resources-explorer-slot > .md-button  { flex: 1; }\n  .resources-fixed-left,\n  .resources-fixed-middle,\n  .resources-fixed-right                 { width: 100%; margin-left: 0; }\n  .resources-list-header                 { display: none; }\n  .resource-row                          { flex-wrap: wrap; padding: 12px 12px 12px 18px; gap: 8px; align-items: flex-start; }\n  .rl-col-checkbox,\n  .rl-col-identity,\n  .rl-col-type,\n  .rl-col-environments,\n  .rl-col-created,\n  .rl-col-updated,\n  .rl-col-toggle,\n  .rl-col-actions                        { flex: 0 0 auto !important; }\n  .rl-col-checkbox                       { width: 44px; }\n  .rl-col-identity                       { width: calc(100% - 44px); }\n  .rl-col-type                           { width: auto; }\n  .rl-col-environments                   { width: 100%; }\n  .rl-col-created,\n  .rl-col-updated                        { display: none; }\n  .rl-col-toggle                         { margin-left: auto; }\n  .rl-col-actions                        { width: auto; }\n}\n/* Full resource identity, with a separate readable ID line. */\n.resource-row__identity .resource-id-pill { max-width: 100%; min-width: 0; flex-shrink: 1; }\n.resource-row__identity .bm-id { max-width: 100%; min-width: 0; }\n.resource-row__identity .bm-id-value { white-space: normal; overflow-wrap: anywhere; }\n.resource-row .rl-col-created .bm-user { max-width: 100%; }\n.resource-row .rl-col-created .bm-user-name { white-space: normal; overflow-wrap: anywhere; }\n\n.resource-filter-error { margin: 12px 0; padding: 12px 16px; color: #b42318; background: #fef3f2; border-radius: 6px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
